import 'alpinejs'
import 'lazysizes'
import 'bootstrap4'

// Application
import '@components/lottie.js'

// Theme
import '@theme/js/core/custom/dropdown.js'
import '@theme/js/core/custom/navbar-sticky.js'
import '@theme/js/core/custom/copy-type.js'

import '@theme/js/core/libs/typed.js'
import '@theme/js/core/libs/countdown.js'
import '@theme/js/core/libs/counter.js'
import '@theme/js/core/libs/masonry.js'

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';


// Global
window.scrollToElement = require('scroll-to-element');

const swiper = new Swiper('.swiper-container', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

tippy('[data-tippy-content]');

// Components
import '@components/GDPRConsent'
import '@components/datepicker/datepicker'
